(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var open = document.querySelector('[data-filter-open]');
    var panel = document.querySelector('[data-filter-panel]');
    var backdrop = document.querySelector('.filter-backdrop');
    if (!panel) return;

    function mobiel() { return window.matchMedia('(max-width: 900px)').matches; }

    function toon() {
      panel.classList.add('is-open');
      if (backdrop) backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
      var sluit = panel.querySelector('[data-filter-close]');
      if (sluit) sluit.focus();
    }

    function verberg() {
      panel.classList.remove('is-open');
      if (backdrop) backdrop.hidden = true;
      document.body.style.overflow = '';
      if (open) open.focus();
    }

    if (open) open.addEventListener('click', toon);
    document.querySelectorAll('[data-filter-close]').forEach(function (el) {
      el.addEventListener('click', verberg);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) verberg();
    });
    window.addEventListener('resize', function () {
      if (!mobiel() && panel.classList.contains('is-open')) verberg();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delivery-zones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var input = document.querySelector('[data-zone-check]');
    var button = document.querySelector('[data-zone-check-btn]');
    var ja = document.querySelector('[data-zone-ja]');
    var nee = document.querySelector('[data-zone-nee]');
    var veld = document.querySelector('[data-zone-veld]');
    var configEl = document.querySelector('[data-zone-config]');
    if (!input || !button || !ja || !nee || !configEl) return;

    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
    if (!config.zones) return;

    function schoon(w) { return String(w || '').replace(/[^0-9]/g, '').slice(0, 4); }

    function check() {
      var zip = schoon(input.value);
      if (zip.length < 4) { ja.hidden = true; nee.hidden = true; return; }

      var match = null;
      config.zones.forEach(function (zone) {
        (zone.postcodes || []).forEach(function (c) {
          if (schoon(c) === zip) match = zone;
        });
      });

      if (match) {
        ja.textContent = ja.dataset.sjabloon.replace('%s', match.name);
        ja.hidden = false;
        nee.hidden = true;
      } else {
        ja.hidden = true;
        nee.hidden = false;
        if (veld) veld.value = zip;
      }
    }

    button.addEventListener('click', check);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); check(); }
    });
    // een oude melding verdwijnt zodra de bezoeker opnieuw typt
    input.addEventListener('input', function () {
      if (schoon(input.value).length < 4) { ja.hidden = true; nee.hidden = true; }
      else check();
    });

    if (nee.querySelector('.gebied__bedankt')) nee.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-counter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stats = document.querySelectorAll('[data-count-to]');
    if (!stats.length) return;

    function toon(n) { return n.toLocaleString(document.documentElement.lang || 'nl-BE'); }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stats.forEach(function (el) { el.textContent = toon(parseInt(el.dataset.countTo, 10) || 0); });
      return;
    }

    var gezien = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || gezien.has(entry.target)) return;
        gezien.add(entry.target);
        var el = entry.target;
        var doel = parseInt(el.dataset.countTo, 10) || 0;
        var start = null;
        function stap(t) {
          if (start === null) start = t;
          var p = Math.min((t - start) / 3200, 1);
          var zacht = 1 - Math.pow(1 - p, 5);
          el.textContent = toon(Math.round(doel * zacht));
          if (p < 1) requestAnimationFrame(stap);
        }
        requestAnimationFrame(stap);
      });
    }, { threshold: 0.35 });

    stats.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
